/* =============================================================================
   AQUA CROWN — All theme JS (vanilla, no dependencies)
   - Rewrites every [data-buy-link] anchor to the brand's product URL
   - Menu drawer open/close
   - Sticky Buy Now bar visibility (mobile-only)
   - Newsletter "Subscribed" micro-feedback (optional)
   ============================================================================= */
(function () {
  'use strict';

  // ----- Product URL bootstrap -----
  // The PRODUCT_URL value comes from <body data-product-url="..."> which is
  // set by the header.liquid section schema. Falls back to a safe default.
  var PRODUCT_URL =
    (document.body && document.body.getAttribute('data-product-url')) ||
    window.AC_PRODUCT_URL ||
    '/products/aqua-crown-spritzer';

  function applyProductUrl() {
    var nodes = document.querySelectorAll('[data-buy-link]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var variant = el.getAttribute('data-variant');
      el.setAttribute('href', variant ? PRODUCT_URL + '?variant=' + variant : PRODUCT_URL);
    }
  }

  // ----- Menu drawer -----
  function bindDrawer() {
    var openBtn = document.querySelector('[data-ac-menu-open]');
    var overlay = document.querySelector('[data-ac-overlay]');
    var menu    = document.querySelector('[data-ac-menu]');
    if (!openBtn || !overlay || !menu) return;
    function open()  { menu.classList.add('is-open');    overlay.classList.add('is-open'); }
    function close() { menu.classList.remove('is-open'); overlay.classList.remove('is-open'); }
    openBtn.addEventListener('click', open);
    overlay.addEventListener('click', close);
    var closers = document.querySelectorAll('[data-ac-close]');
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', close);
  }

  // ----- Sticky Buy bar visibility + collapse/expand -----
  function bindStickyBuy() {
    var bar    = document.getElementById('ac-sticky-buy');
    var tab    = document.getElementById('ac-sticky-tab');
    var hero   = document.getElementById('ac-section-hero');
    var footer = document.getElementById('ac-section-footer');
    if (!bar || !hero || !footer) return;

    var collapsed = false;

    function paint() {
      var heroBottom = hero.getBoundingClientRect().bottom;
      var footerTop  = footer.getBoundingClientRect().top;
      var inRange = heroBottom < 60 && footerTop > 80;
      var showBar = inRange && !collapsed;
      var showTab = inRange &&  collapsed;
      bar.classList.toggle('is-visible', showBar);
      bar.setAttribute('aria-hidden', showBar ? 'false' : 'true');
      if (tab) {
        tab.classList.toggle('is-visible', showTab);
        tab.setAttribute('aria-hidden', showTab ? 'false' : 'true');
      }
    }

    // Collapse → switch from full bar to side tab
    var closeBtn = document.querySelector('[data-ac-stickybuy-collapse]');
    if (closeBtn) closeBtn.addEventListener('click', function () { collapsed = true; paint(); });
    // Expand → switch back from side tab to full bar
    if (tab) tab.addEventListener('click', function () { collapsed = false; paint(); });

    window.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
    paint();
  }

  // ----- Year stamp -----
  function stampYear() {
    var el = document.getElementById('ac-year');
    if (el) el.textContent = new Date().getFullYear();
  }

  // ----- Init -----
  function init() {
    applyProductUrl();
    bindDrawer();
    bindStickyBuy();
    stampYear();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
